export default __webpack_public_path__ + "static/B0227-7d87b09e7f874c5227eeedfe88166499.png";